<!-- ================管理端-专题活动====================-->
<template>
    <div class="admin-screen-container">
        <div class="admin-title-container">专题活动列表</div>
        <div class="admin-btn-container">
            <div class="admin-btn-item" @click="handleCreate">创建活动</div>
            <div class="admin-btn-item" @click="handleScaleAdd">活动评审量表</div>
        </div>
        <div class="admin-search4-100">
            <div class="admin-search25">
                <div class="admin-search25-name">活动状态:</div>
                <div class="admin-search25-item">
                    <el-select clearable @change="getList()" v-model="queryParams.status" placeholder="请选择">
                        <el-option v-for="item in statusList" :key="item.value" :label="item.name"
                                   :value="item.value" />
                    </el-select>
                </div>
            </div>
            <div class="admin-search25">

            </div>
            <div class="admin-search25"></div>
            <div class="admin-search25">
                <div class="admin-search25-item-input">
                    <el-input class="admin-input1" v-model="queryParams.name" placeholder="请输入活动名称">
                        <template #append>
                            <el-button @click="handleQuery" class="name-search-btn"
                                       type="primary" icon="el-icon-search" />
                        </template>
                    </el-input>
                </div>
            </div>
        </div>
        <!--数据列表-->
        <div class="mt5">
            <el-table v-loading="loading"
                      cell-class-name="admin-table"
                      show-overflow-tooltip
                      height="calc(100vh - 255px)"
                      :data="dataList"
                      class="admin-table"
                      highlight-current-row>
                <el-table-column type="index" fixed="left" align="center" label="序号" width="60" />
                <el-table-column width="100" align="center" label="活动状态" prop="status">
                    <template #default="scope">
                        <div v-if="scope.row.status === 0">初始阶段</div>
                        <div v-if="scope.row.status === 1">报名阶段</div>
                        <div v-if="scope.row.status === 2">初审阶段</div>
                        <div v-if="scope.row.status === 3">复审阶段</div>
                        <div v-if="scope.row.status === 4">终审阶段</div>
                        <div v-if="scope.row.status === 5">现场评比</div>
                        <div v-if="scope.row.status === 6">活动结束</div>
                    </template>
                </el-table-column>
                <el-table-column width="220" align="center" label="活动名称" prop="activityName">
                    <template #default="scope">
                        <div :title="scope.row.activityName" @click="goDetail(scope.row)" style="color: #377f7f;"
                             class="text-one cursor">
                            {{ scope.row.activityName }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="120" align="center" label="活动级别" prop="activityLevelName" />
                <el-table-column width="120" align="center" label="审核模式" prop="checkModeName" />
                <el-table-column width="260" align="center" label="报名阶段" prop="time">
                    <template #default="scope">
                        <div>
                            {{ timestampToTime(scope.row.beginTime) }}至{{ timestampToTime(scope.row.endTime) }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="180" align="center" label="学段·年级·学科">
                    <template #default="scope">
                        <el-text>
                            {{scope.row.periodName?scope.row.periodName:'--'}}•{{scope.row.gradeName?scope.row.gradeName:'--'}}•{{scope.row.subjectName?scope.row.subjectName:'--'}}
                        </el-text>
                    </template>
                </el-table-column>
                <el-table-column width="120" fixed="right" align="center" label="操作"
                                 class-name="small-padding fixed-width">
                    <template #default="scope">
                        <el-popover placement="bottom" trigger="click"
                                    :width="100" popper-style="padding: 5px 0 0">
                            <template #reference>
                                <el-button type="primary" size="default">操作</el-button>
                            </template>
                            <template #default>
                                <div>
                                    <div class="text-item" v-if="scope.row.status != 6 && (scope.row.isCreate || role == 1 || role == 2)">
                                        <el-text type="primary" @click="handleUpdate(scope.row)">编辑</el-text>
                                    </div>
                                    <div class="text-item" v-if="role == 1 || role == 2 || userId == scope.row.activityLeader">
                                        <el-text type="primary" @click="handleManager(scope.row)">管理</el-text>
                                    </div>
                                    <div class="text-item" v-if="scope.row.status == 0">
                                        <el-text type="primary" @click="handleRelease(scope.row)">发布</el-text>
                                    </div>
                                    <div class="text-item" v-if="scope.row.status != 0 && scope.row.status != 6">
                                        <el-text type="primary" @click="handleStop(scope.row)">停止</el-text>
                                    </div>
                                    <div class="text-item">
                                        <el-popconfirm
                                            confirm-button-text="是"
                                            cancel-button-text="否"
                                            icon-color="#626AEF"
                                            title="确定删除该活动?"
                                            @confirm="handleDelete(scope.row)">
                                            <template #reference>
                                                <el-text type="danger">删除</el-text>
                                            </template>
                                        </el-popconfirm>
                                    </div>
                                </div>
                            </template>
                        </el-popover>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!--  分页  -->
        <div>
            <pagination :background="false"
                        :pageSizes="[10, 20, 30]"
                        :total="total"
                        v-model:page="queryParams.pageNum"
                        v-model:limit="queryParams.pageSize"
                        @pagination="getList" />
        </div>
    </div>

</template>
<script>
import { activityPage, activityRelease, activityStop, activityDelete } from "@/api/admin/activity";
import { timestampToTime } from "@/utils/date";

export default {
    components: {},
    name: "activityIndex",
    data() {
        return {
            timestampToTime,
            role: this.$storage.get("role"),
            userId: '',
            loading: false,
            total: 0,
            dataList: [],
            queryParams: {
                name: '',
                status: '',
                title: '',
                periodKey: '',
                gradeKey: '',
                subjectKey: '',
                type: '',
                nature: '',
                pageNum: 1,
                pageSize: 10,
            },
            statusList: [
                { name: '初始阶段', value: 0 },
                { name: '报名阶段', value: 1 },
                { name: '初审阶段', value: 2 },
                { name: '复审阶段', value: 3 },
                { name: '终审阶段', value: 4 },
                { name: '现场评比', value: 5 },
                { name: '活动结束', value: 6 },
            ],
        }
    },
    computed: {},
    watch: {},
    created() {
        this.initUserId();
        this.getList();
    },
    mounted() {},
    methods: {
        initUserId() {
            const userInfo = this.$storage.get("userInfo");
            if (userInfo) {
                try {
                    this.userId = JSON.parse(userInfo).userId;
                } catch (e) {
                    this.userId = '';
                }
            }
        },
        /** 查询活动列表 */
        getList(e) {
            this.loading = true;
            this.dataList = [];
            if (e) {
                this.queryParams.pageNum = e.page;
                this.queryParams.pageSize = e.limit;
            }
            activityPage(this.queryParams).then(res => {
                if (res.data && res.data.code == 1) {
                    this.total = res.data.data.total;
                    this.dataList = res.data.data.list;
                }
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            })
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        /** 重置查询条件 */
        resetQuery() {
            this.queryParams = {
                name: '',
                status: '',
                title: '',
                periodKey: '',
                gradeKey: '',
                subjectKey: '',
                type: '',
                nature: '',
                pageNum: 1,
                pageSize: 10,
            };
            this.getList();
        },
        /** 创建活动 */
        handleCreate() {
            this.$router.push({
                path: "/activityCreate",
            });
        },
        /** 编辑活动 */
        handleUpdate(row) {
            this.$router.push({
                path: "/activityCreate",
                query: {
                    activityId: row.activityId,
                }
            });
        },
        /** 活动详情 */
        goDetail(row) {
            this.$router.push({
                path: "/activityDetail",
                query: {
                    activityId: row.activityId,
                }
            });
        },
        /** 活动管理 */
        handleManager(row) {
            this.$router.push({
                path: "/activityManager",
                query: {
                    activityId: row.activityId,
                }
            });
        },
        /** 活动评审量表 */
        handleScaleAdd() {
            this.$router.push({
                path: "/activityScale",
            });
        },
        /** 发布活动 */
        handleRelease(row) {
            this.$confirm('确定发布该活动?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                activityRelease({ activityId: row.activityId }).then(res => {
                    if (res.data && res.data.code == 1) {
                        this.$message.success("发布成功");
                        this.getList();
                    } else {
                        this.$message.error(res.data.msg || "发布失败");
                    }
                })
            });
        },
        /** 停止活动 */
        handleStop(row) {
            this.$confirm('确定停止该活动?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                activityStop({ activityId: row.activityId }).then(res => {
                    if (res.data && res.data.code == 1) {
                        this.$message.success("停止成功");
                        this.getList();
                    } else {
                        this.$message.error(res.data.msg || "停止失败");
                    }
                })
            });
        },
        /** 删除活动 */
        handleDelete(row) {
            activityDelete({ activityId: row.activityId }).then(res => {
                if (res.data && res.data.code == 1) {
                    this.$message.success("删除成功");
                    this.getList();
                } else {
                    this.$message.error(res.data.msg || "删除失败");
                }
            })
        },
    },
}
</script>
<style scoped>
.name-search-btn {
    background-color: #377f7f !important;
    color: #fff !important;
}
</style>
